import Dropdown11 from "./theme11";
import Dropdown12 from "./theme12";

export default function Dropdown(props) {
  switch (props.theme) {
    case "theme11":
      return <Dropdown11 {...props} />;
    case "theme12":
      return <Dropdown12 {...props} />;
    default:
      return <Dropdown11 {...props} />;
  }
}
